import ACTIONS from "../../constants/actions";

const storageKey = 'coupon';
const dataFromLs = localStorage.getItem(storageKey);
const defaultData = {};
const initialState = dataFromLs ? JSON.parse(dataFromLs) : defaultData;

export default function coupon(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.COUPON.UPDATE:
			localStorage.setItem(storageKey, JSON.stringify(action.data));
			return action.data;
		case ACTIONS.COUPON.CHANGE_LIVE_OPT:
			return Object.assign({}, state, {...action.data});
		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/coupon.js